import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { PageLoader } from '@customerio/pluma-components/react';

const NewsletterContentPage = lazy(
  () => import('@/pages/workspaces/broadcasts/newsletter/overview/content/index.page'),
);

function NewsletterContentRoute() {
  const { newsletterId } = Route.useParams();
  return (
    <Suspense fallback={<PageLoader label="Loading…" />}>
      <NewsletterContentPage key={newsletterId} newsletterId={newsletterId} />
    </Suspense>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/content',
)({ component: NewsletterContentRoute });
